import Index from '@/views/common/Index'
import IndexWeb from '@/views/common/IndexWeb'
import Home from '@/views/home/Home'
import homeBig from '@/views/home/homeBig'
import Login from '@/views/common/Login'
import LoginNoPage from '@/views/common/loginNoPage'

export default [
  {
    path: '/',
    name: 'login',
    component: Login,
  },
  {
    path: '/loginNoPage',
    name: 'LoginNoPage',
    component: LoginNoPage,
  },
  {
    path: '/index',
    name: 'index',
    redirect: 'homeBig',
    meta: {auth: true},
    component: Index,
    children: [
      //----------首页----------
      {
        path: '/home',
        meta: {auth: true, title: "首页"},
        component: Home,
        children: [{
            path: '/',
            name: 'home',
            component: resolve => require(['@/views/home/HomeList'], resolve)
          },{
            path: '/home/user',
            name: 'home/user',
            component: resolve => require(['@/views/home/HomeUser'], resolve)
          },

        ],
      },
    ]
  },
  {
    path: '/homeBig',
    name: 'homeBig',
    meta: {auth: true},
    component: homeBig,
  },
  {
    path: '/indexWeb',
    name: 'indexWeb',
    meta: {auth: true},
    component: IndexWeb,
  }
]



// WEBPACK FOOTER //
// ./src/router/home.js